import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-olive-ink text-bone flex flex-col">
      <div className="p-6 md:p-10 flex items-center justify-between">
        <a href="/" className="inline-flex items-center gap-2 text-sm text-bone/60 hover:text-bone transition-colors">
          <ArrowLeft size={16} /> zurück zur Website
        </a>
        <ThemeToggle className="p-2 text-bone/60 hover:text-bone" />
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-20">
        <div className="w-full max-w-sm">
          <div className="h-32 w-32 rounded-full bg-bone flex items-center justify-center mb-6 shadow-lg">
            <img src="/logo.webp" alt="Tonpoesie" className="h-28 w-28 rounded-full object-cover" />
          </div>
          <p className="text-xs uppercase tracking-[0.28em] text-sage mb-3">Tonpoesie · Studio-Verwaltung</p>
          <h1 className="font-serif text-5xl tracking-tight mb-8">Anmelden</h1>
          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <Input required type="email" placeholder="E-Mail" data-testid="login-email"
                   value={email} onChange={(e) => setEmail(e.target.value)}
                   className="bg-transparent border-bone/25 text-bone placeholder:text-bone/40 py-6" />
            <Input required type="password" placeholder="Passwort" data-testid="login-password"
                   value={password} onChange={(e) => setPassword(e.target.value)}
                   className="bg-transparent border-bone/25 text-bone placeholder:text-bone/40 py-6" />
            {error && <p className="text-sm text-clay" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="login-submit"
                    className="w-full rounded-full bg-sage text-sage-deep hover:bg-sage-dark py-6 text-base">
              {loading ? "Anmelden…" : "Anmelden"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
